module.exports = __webpack_public_path__ + "img/dashuju.40325281.png";